import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import Preloader from "../Preloader";
import { Redirect } from 'react-router-dom';
import kosodelnik from "../../images/kosodelnik.png";
import kosodelnikModry from "../../images/kosodelnik-modry.png"

class Muihtil extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            bodyPost: {},
            isLoading: true,
            index: 1,
            headerBgClass: "home",
            firstRectSrc: kosodelnikModry,
            secondRectSrc: kosodelnik, 
            nextHeaderBgIndex: 2,
            firstArticle: "",
            secondArticle: "hidden",
            error: {},
            redirectInternalError: false,
        };

        this.bgToggle = this.bgToggle.bind(this);
    }

    bgToggle(number) {
        if (number === 1) {
          this.setState({
              firstRectSrc: kosodelnikModry,
              secondRectSrc: kosodelnik,
              headerBgClass: "home",
              nextHeaderBgIndex: 2,
              firstArticle: "",
              secondArticle: "hidden"
          });
        } else {
            this.setState({
                firstRectSrc: kosodelnik,
                secondRectSrc: kosodelnikModry,
                headerBgClass: "recultivation",
                nextHeaderBgIndex: 1,
                firstArticle: "hidden",
                secondArticle: ""
            });
        }
      }

    componentDidMount(){
               this.interval = setInterval(() => this.bgToggle(this.state.nextHeaderBgIndex), 14000);
               this.setState({ isLoading: false });
    }
  
    componentWillUnmount() {
      clearInterval(this.interval);
    }

    renderHeader = () => {
        return(
            <header className={"contact-header-muihtil " + this.state.headerBgClass}>
                <Navbar/>
    
                <div className="sd-container">
                    <section id="sub-header">
                        <div className="row mb-5">
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h6 className="sub-header-caption text-uppercase">MUIHTIL Dukla a.s.</h6>
                                </div> 
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="sub-header-chevrons">
                                    <img
                                        src={this.state.firstRectSrc}
                                        alt="chevron_white"
                                        className="first header-toogle-button"
                                        onClick={() => this.bgToggle(1)}
                                    />
                                    <img
                                        src={this.state.secondRectSrc}
                                        alt="chevron_sd"
                                        className="second header-toogle-button"
                                        onClick={() => this.bgToggle(2)}
                                    />
                                    </span>
                                </div>                      
                            </div>                        
                        </div>
                    </section>
                </div>
            </header> 
        );
    }
    
    renderMainContainer = () => {
        return(
            <section id="main-container" className="mb-5">
                <div className="sd-container">
                    <section id="detail-contact-muihtil" className="pb-3 pt-3 pl-3 pl-md-5 pr-3 pr-md-5">
                        <div className="row">
                            <div className="col-12">
                                <div className="col-12 d-flex justify-content-between pl-0  pr-0  sd-pointer">
                                    <h4 className="text-white text-uppercase pt-4 pb-2">Adresa</h4>
                                </div>
                                <div className="pl-0 pr-0 pb-4 ">
                                    <div className="row pb-2">
                                        <div className="col-sm-12 col-md-6">MUIHTIL Dukla a.s.<br />
                                    Osada Dukla 253<br />
                                    Újezdeček, 415 01</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 d-flex justify-content-between sd-pointer">
                                    <h4 className="text-white text-uppercase pt-4 pb-2">Fakturační údaje</h4>
                            </div>
                            <div className="col-12 pl-0 pr-0 d-flex justify-content-between pb-4 ">
                                <div className="col-sm-12 col-md-6"><b>IČO</b><br/>24045586</div>
                            </div>
                        </div>
    
                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                                                <div className="row">
                            <div className="col-12 d-flex justify-content-between sd-pointer">
                                    <h4 className="text-white text-uppercase pt-4 pb-2">E-mail</h4>
                            </div>
                            <div className="col-12 pl-0 pr-0 d-flex justify-content-between pb-4 ">
                                <div className="col-sm-12 col-md-6"><a href="mailto:muihtil@sdas.cz" className="text-white">muihtil@sdas.cz</a></div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col">
                                <hr className="sd-contact-hr m-0" />
                            </div>
                        </div>

                                                <div className="row">
                            <div className="col-12 d-flex justify-content-between sd-pointer">
                                    <h4 className="text-white text-uppercase pt-4 pb-2">Zápis v obchodním rejstříku</h4>
                            </div>
                            <div className="col-12 pl-0 pr-0 d-flex justify-content-between pb-4 ">
                                <div className="col-sm-12 col-md-6">Společnost je zapsána v obchodním rejstříku vedeném Krajským soudem v Ústí nad Labem, oddíl B, vložka 2985.</div>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        );
    }
    
    renderSecondaryContainer = () => {
        return(
            <section id="secondary-container" className="sd-hidden-xs contact-secondary-container"></section>
        );
    }
    
    renderFooter = () => {
        return(
            <footer className="footer-contact-height">
                <div className="sd-container">
                    <section id="footer-content" className="footer-top-padding footer-top-padding-contact">
                        <Footer/>
                    </section>
                </div>
            </footer>           
        );
    }
    
    render(){
        const { isLoading, redirectInternalError, error } = this.state;
    
        return (            
            <section id="web">
                {isLoading ? (
                    <Preloader isLoaded={!isLoading} />
                ) : (redirectInternalError ? (
                    <Redirect to={{
                        pathname: "/500",
                        state: { error: error }
                      }} />
                ) : ( 
                    <div className="wrapper">
                        {this.renderHeader()}
    
                        {this.renderMainContainer()}
    
                        {this.renderSecondaryContainer()}
    
                        {this.renderFooter()}
                    </div>
                ))}
            </section>        
        )
    }
}

export default Muihtil;